import React, { useState, useEffect } from "react";
import Head from "next/head";
import Router from "next/router";

import Header from "../../components/Header";
import BookForm from "../../components/Book/Form";
import Spinner from "~/shared/Spinner";

const GOOGLE_MAPS_KEY = process.env.NEXT_PUBLIC_GOOGLE_MAPS_KEY;

const Book = (props) => {
    const [utmSource, setUtmSource] = useState();
    const [currentStep, setCurrentStep] = useState(1);

    useEffect(() => {
        Router.push("/marketplace/book");
        const utm = window.sessionStorage.getItem("utm_source") || props.utmSource;
        setUtmSource(utm);
    }, []);

    return (
        <>
            <div className="head-logged">
                <div className="container">
                    <button
                        className="btn-return"
                        type="button"
                        onClick={() => (currentStep <= 1 ? Router.push("/") : setCurrentStep(currentStep - 1))}
                    >
                        <svg viewBox="0 0 100 100">
                            <path
                                d="M96.2,43.3L61.7,8.8c-3.2-3.2-8.4-3.2-11.6,0s-3.2,8.4,0,11.6l21.5,21.5H9.2C4.7,41.8,1,45.5,1,50c0,4.5,3.7,8.2,8.2,8.2
                h62.4L50.1,79.6c-3.2,3.2-3.2,8.4,0,11.6c1.6,1.6,3.7,2.4,5.8,2.4s4.2-0.8,5.8-2.4l34.5-34.5C98,54.9,99,52.5,99,50
                C99,47.5,98,45.1,96.2,43.3z"
                            />
                        </svg>
                    </button>
                </div>
            </div>
            <div className="main">
                <Spinner />
            </div>
        </>
    );
};

Book.getInitialProps = ({ query }) => ({
    category: Number(query.c),
    utmSource: query.utm_source,
});

export default Book;
